<div class="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-md">
    <h1 class="text-3xl font-extrabold text-gray-900 mb-2 text-center">Terms of Use</h1>
    <p class="text-sm text-gray-500 mb-8 text-center">Last Updated: August 30, 2025</p>

    <p class="text-gray-700 mb-8 leading-relaxed">
      Welcome to Hector Investment LLC OPCI. By accessing or using our website,
      <a href="https://investdev.hectorinvestment.ai/" target="_blank" rel="noopener" class="text-blue-600 hover:underline">https://investdev.hectorinvestment.ai/</a>, you agree to be bound by these Terms of Use ("Terms").
    </p>

    <div class="space-y-6 text-gray-700 leading-relaxed">
      <section>
        <h2 class="text-xl font-bold text-gray-800 mb-3">1. No Financial Advice</h2>
        <p>
          The content on this Site, including but not limited to text, graphics, testimonials, and the ROI Calculator, is for informational purposes only. It does not constitute financial, investment, legal, or tax advice. You should not construe any such information as a recommendation to buy, sell, or hold any investment. You should consult with a qualified professional advisor before making any investment decisions.
        </p>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mb-3">2. Investment Risks</h2>
        <p>
          All investments involve risk, including the potential loss of the principal amount invested. Past performance is not an indicator or guarantee of future results. The "up to 100% ROI" and other stated returns represent potential outcomes and are not guaranteed. Hector Investment LLC OPC does not guarantee any specific investment outcome.
        </p>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mb-3">3. ROI Calculator</h2>
        <p>
          The ROI Calculator is provided as a tool to illustrate potential returns based on the inputs you provide. The results are estimates, are for prediction purposes only, and are not a guarantee of actual investment performance.
        </p>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mb-3">4. Intellectual Property</h2>
        <p>
          All content on this Site, including the logo, text, and design, is the property of Hector Investment LLC OPC and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or otherwise use any content without our express written permission.
        </p>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mb-3">5. Limitation of Liability</h2>
        <p>
          Hector Investment LLC OPC will not be liable for any direct, indirect, incidental, or consequential damages arising out of your use of, or inability to use, this Site or your reliance on any information provided on the Site.
        </p>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mb-3">6. Governing Law</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of the United Arab Emirates, without regard to its conflict of law principles.
        </p>
      </section>

      <section>
        <h2 class="text-xl font-bold text-gray-800 mb-3">7. Changes to Terms</h2>
        <p>
          We reserve the right to modify these Terms at any time. Your continued use of the Site after any such changes constitutes your acceptance of the new Terms.
        </p>
      </section>
    </div>
  </div>
</div>
